import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bdo-toggle-button',
    templateUrl: './toggle-button.component.html',
    styleUrls: ['./toggle-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class ToggleButtonComponent {

  @Input() enabled: boolean;
  @Input() id: string;
  @Input() description: string;
  @Input() labelLeft: string;
  @Input() labelRight: string;
  @Input() mode: 'onoff' | 'switch' = 'onoff';
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() toggle = new EventEmitter<string>();

  constructor() {
  }

  public changeOption() {
    this.toggle.emit(this.id);
  }

}
